import { Controller } from "@hotwired/stimulus"

// Off-canvas sidebar for phones. Above md the sidebar is static and this
// controller stays inert — `open` only drives the mobile transform.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.close()
    // A Turbo visit swaps <body>, but the drawer must also close when the user
    // taps a nav link that resolves to the *current* page (no body swap).
    this.closeHandler = () => this.close()
    document.addEventListener("turbo:visit", this.closeHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.closeHandler)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.backdropTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.backdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    this.panelTarget.classList.contains("-translate-x-full") ? this.open() : this.close()
  }
}
